<template>
  <div>
    <b-card :title="title">
      <b-modal v-model="modalNext" title="Get Next Queue">
        <b-container>
          <b-row>
            <b-col cols="12">
              Get Next Queue?
            </b-col>
          </b-row>
        </b-container>
          <template #modal-footer>
            <div class="w-100 d-flex justify-content-center align-items-center">
              <b-button variant="success" class="ml-1" @click="nextQueue"
                >Yes</b-button
              >
              <b-button variant="danger" class="ml-1" @click="modalNext = false"
                >No</b-button
              >
            </div>
          </template>
        </b-modal>
  
        <b-modal v-model="modalMiss" title="Get Next Queue">
          <b-container>
            <b-row>
              <b-col cols="12">
                Miss This Queue?
              </b-col>
            </b-row>
          </b-container>
  
          <template #modal-footer>
            <div class="w-100 d-flex justify-content-center align-items-center">
              <b-button variant="success" class="ml-1" @click="missQueue"
                >Yes</b-button
              >
              <b-button variant="danger" class="ml-1" @click="modalMiss = false"
                >No</b-button
              >
            </div>
          </template>
        </b-modal>

        <b-modal v-model="modalMissedQueue" title="Missed Queue List" size="lg">
          <b-container>
            <b-row>
              <b-col cols="12">
                <b-table 
                  :items="missedQueueTableData" 
                  :fields="missedQueueFields" 
                  class="text-center"
                  :per-page="10"
                  :current-page="currentPage"
                >
                  <template #cell(index)="row">
                    {{ row.index + 1 }}
                  </template>
                  <template #cell(queueNumber)="row">
                    {{ transformQueueNumber(row.item.queueNumber) }}
                  </template>
                  <template #cell(name)="row">
                    {{ row.item.name }}
                  </template>
                  <template #cell(poNumber)="row">
                    {{ row.item.poNumber }}
                  </template>
                  <template #cell(action)="row">
                    <b-button
                      v-if="form.disableSAPEkiosk"
                      variant="danger"
                      size="sm"
                      @click="removeMissedQueueItem(row.item)"
                    >
                      Create order in SAP manually
                    </b-button>
                    <b-button
                      v-else
                      variant="primary"
                      @click="goToProcess(row.item.poNumber, row.item.queueNumber)"
                    >
                      Process
                    </b-button>
                  </template>
                </b-table>
                <b-pagination
                  v-if="missedQueueTableData.length > 10"
                  v-model="currentPage"
                  :total-rows="missedQueueTableData.length"
                  :per-page="10"
                  align="center"
                  class="mt-3"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-container>
          <template #modal-footer>
            <div class="w-100 d-flex justify-content-center align-items-center">
              <b-button variant="primary" @click="modalMissedQueue = false">
                Close
              </b-button>
            </div>
          </template>
        </b-modal>
        <b-row>
          <b-col cols="6" class="adjust-on-mobile">
            <b-button
              size="md"
              variant="primary"
              @click="$router.go(-1)"
              >Back</b-button
            >
          </b-col>
        </b-row>
      <b-row>
        <b-col cols="12" class="mt-2 mb-2" >
          <b-table :items="currentQueue" :fields="fields" class="text-center">
            <template #cell(name)="row">
              <h2>{{ row.item.name ? row.item.name : '-' }}</h2>
            </template>
            <template #cell(queueNumber)="row">
              <h2>#{{ transformQueueNumber(row.item.queueNumber) }}</h2>
            </template>
            <template #cell(poNumber)="row">
              <h2>{{ String(row.item.poNumber ? row.item.poNumber : '-') }}</h2>
            </template>
            <template #cell(status)="row">
              <h2>{{ String(row.item.status ? row.item.status : '-') }}</h2>
            </template>
            <template #cell(action)="row">
              <span v-if="form.disableSAPEkiosk" style="font-size: 0.95rem;">
                Create order in SAP manually
              </span>
              <b-button
                v-else
                @click="goToProcess(row.item.poNumber)"
                variant="primary"
                :disabled="row.item.poNumber == '-' && row.item.name == '-'"
                >
                Process Order
              </b-button>
            </template>
          </b-table>
        </b-col>
  

      </b-row>
      <b-row>
        <b-col cols="12" class="mt-2 mb-2" >
          <h2>Wait List</h2>
          <b-table :items="[numberWaiting]" :fields="waitingFields">
            <template #cell(missed)="row">
              {{ row.item.missed || 0 }}
              <b-button
                v-if="(row.item.missed || 0) > 0"
                size="sm"
                variant="info"
                class="ml-2"
                @click="openMissedQueueModal"
                >View</b-button
              >
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>      
        <!--this for warehouse role. temporary check when open this page from shipping table list-->
        <b-col cols="6" style="margin-bottom: 10px;" class="adjust-on-mobile">
          <b-button
            @click="modalNext = true"
            class="w-100 d-flex justify-content-center"
            variant="success"
            :disabled="!canNext"
            >Next Queue</b-button
          >
        </b-col>
        <b-col cols="6" style="margin-bottom: 10px;" class="adjust-on-mobile">
          <b-button
            @click="modalMiss = true"
            class="w-100 d-flex justify-content-center"
            variant="secondary"
            :disabled="currentQueue[0] ? currentQueue[0].queueNumber=='-' : false"
            >Miss Queue</b-button
          >
        </b-col>
      </b-row>
    </b-card>

    <b-modal 
    v-model="modalOpen" 
    title="Notification" 
    no-close-on-backdrop
    no-close-on-esc
    ok-only
    @hide="closeModal"
    >
    <h5 class="text-center mb-4">SO is created for non Cash Order. Please create the Delivery Order</h5>
    <h6 class="text-center">ignore this message if Delivery Order is already created</h6>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data() {
      return {
        modalNext:false,
        modalMiss:false,
        modalMissedQueue:false,
        fields: [
          { key: "name", label: "Name"},
          { key: "queueNumber", label: "Number" },
          { key: "poNumber", label: "PO Number" },
          { key: "status", label: "Status" },
          { key: "action", label: "Action" },
        ],
        waitingFields:[
          { key: "dealer", label: "Online Dealer" },
          { key: "counter", label: "Walk In Cash Sales" },
          { key: "customer", label: "Online Cash Sales" },
          { key: "missed", label: "Missed Queue" },
        ],
        currentQueue:[],
        numberWaiting:{
          counter:0,
          dealer:0,
          counter:0,
        },
        poId:"-",
        form: {
          _id:"",
          name:"",
          warehouse:""
        },
        modalOpen: false,
        isPolling: false,
        intervalId: null,
        canNext:false,
        missedQueueTableData: [],
        missedQueueFields: [
          { key: "index", label: "No" },
          { key: "queueNumber", label: "Queue Number" },
          { key: "name", label: "Name" },
          { key: "poNumber", label: "PO Number" },
          { key: "action", label: "Action" }
        ],
        currentPage: 1,
      }
  },
  beforeDestroy() {
    this.clearPollingInterval();
  },
  mounted() {
    var id =this.$route.params.id
    localStorage.setItem("lastCounterID", id)
    this.getCounter(id).then((res) => {
      this.form = res
      if (!this.isSalesmanIDValid(this.form.salesmanID)) {
        this.$router.replace({
          name: "counter-edit",
          params: { id: this.form._id },
          query: { requireSalesmanID: "1" },
        });
        return;
      }
      
      this.currentQueue = (res.currentQueue==undefined)?[{name:"-",queueNumber:0}]:[res.currentQueue]

      if(this.currentQueue[0].queueNumber == 0 || res.disableSAPEkiosk){
        this.canNext = true;
      }
      this.fetchLatest()
      this.loopGetLatest()
      
      }).catch((err) => {
        console.error(err)
        this.$bvToast.toast(`${err.response.data.errors[0].message}`, {
        title: "Failed",
        variant: "danger",
        solid: true,
      })
    })
  },
  methods: {
    ...mapActions({
      getCounter:"counter/getCounter",
      counterNextQueue:"counter/counterNextQueue",
      counterMissQueue:"counter/counterMissQueue",
      addCounterIDToPO: "purchase/addCounterIDToPO",
      getPO: "purchase/getPurchaseByPONumber",
      getCounterLatest:"counter/getCounterLatest",
      fetchQueueMissed: "queue/fetchQueueMissed",
      removeQueueMissedItem: "queue/removeQueueMissedItem"
    }),
    isSalesmanIDValid(salesmanID) {
      return /^[A-Za-z0-9]{8}$/.test(String(salesmanID || "").trim());
    },
    nextQueue() {
      //this.clearPollingInterval();
      this.loopGetLatest();
      this.counterNextQueue(this.form._id).then((res) => {
        console.log(res)
        this.modalNext=false
        var name= (res.name)?res.name:"-";
        var queueNumber= (res.queueNumber)?res.queueNumber:0
        var poNumber = (res.poNumber)?res.poNumber:"-"
        var status = (res.status)?res.status:"-"
        this.poNumber = poNumber

        if (poNumber !== '-') {
          //disable loopGetPo, functionally changed to loopGetLatest
          //this.loopGetPo()
        }
        this.currentQueue=[{name:name,queueNumber:queueNumber, poNumber:poNumber, status:status}]
        if (res.queueNumber == '-' && res.name == '-') {
          this.$bvToast.toast("No queue remains", {
            title: "Success",
            variant: "success",
            solid: true,
          });
          return
        }
        this.$bvToast.toast(`Get queue number ${this.transformQueueNumber(queueNumber)}`, {
          title: "Success",
          variant: "success",
          solid: true,
        });
      }).catch((err) => {
          console.error(err)
          this.$bvToast.toast(`${err.response.data.errors[0].message}`, {
          title: "Failed",
          variant: "danger",
          solid: true,
          })
      })
    },
    missQueue() {
      //this.clearPollingInterval();
      this.counterMissQueue(this.form._id).then((res) => {
          this.modalMiss=false
          var name= (res.name)?res.name:"-";
          var queueNumber= (res.queueNumber)?res.queueNumber:'-'
          var poNumber = (res.poNumber)?res.poNumber:"-"
          var status = (res.status)?res.status:"-"
          this.poNumber = poNumber

          if (poNumber !== '-') {
            //disable loopGetPo, functionally changed to loopGetLatest
            //this.loopGetPo()
          }
          // console.log('currentQueue',this.currentQueue)
          // this.currentQueue=[{name:name,queueNumber:queueNumber, poNumber:poNumber, status:status}]
          this.currentQueue=[{name:'-',queueNumber:'-', poNumber:'-', status:'-'}];

          this.$bvToast.toast(`Queue marked as missed`, {
            title: "Success",
            variant: "success",
            solid: true,
        });
      }).catch((err) => {
          console.error(err)
          this.$bvToast.toast(`${err.response.data.errors[0].message}`, {
          title: "Failed",
          variant: "danger",
          solid: true,
          })
      })
    },
    goToProcess(poNumber,missedQueueNumber="") {
      this.clearPollingInterval();
      if (poNumber === '-' || poNumber === '') {
       // Buat path URL dari route
        var toAddQuery = { counterID: this.form._id }
        if(missedQueueNumber != ""){
          toAddQuery.missedQueueNumber = missedQueueNumber;
        }
        const routeData = this.$router.resolve({
          name: 'kiosk-po-add',
          query: toAddQuery
        });

        this.$router.push(routeData.href)

        // Buka di tab baru
        //window.open(routeData.href, '_blank');
      } else {
        const data = {
          poNumber: poNumber,
          counterID: this.form._id
        }
        this.addCounterIDToPO(data)
        .then((res) => {

          var poIDToOpen = (res._id)?res._id:this.poId
          var statusToOpen = (res.orderStatus !== undefined)?res.orderStatus:this.currentQueue[0].status


          var toEditStatus = ["Created", "Editing",""];
          var toProcessStatus = ["Checking", "SO Created", "DO Processed","PO Fail","Awaiting Discount Approval"];

          console.info("id",poIDToOpen)
          console.info("status",statusToOpen)
          if(toEditStatus.includes(statusToOpen)){
            var toEditQuery = { }
            if(missedQueueNumber != ""){
              toEditQuery.missedQueueNumber = missedQueueNumber;
            }
            this.$router.push({
              name: 'kiosk-po-edit',
              params: { idKioskPO: poIDToOpen },
              query: toEditQuery
            })
          }else if (toProcessStatus.includes(statusToOpen)){
            this.$router.push({
              name: 'kiosk-po-detail',
              params: { id: poIDToOpen }
            })

            
          }
          //window.open(routeData.href, '_b
        }).catch((err) => {
          console.error(err)
          this.$bvToast.toast(`${err.response.data.errors[0].message}`, {
          title: "Failed",
          variant: "danger",
          solid: true,
          })
        })
      }
    },
    closeModal() {
      localStorage.removeItem("processingSONotif")
      this.modalOpen = false
    },
    async fetchLatest(){
      try {
          const res = await this.getCounterLatest(this.form._id);

          let tempQueue = this.currentQueue;
          tempQueue[0].status = res.poStatus === "" ? "Created" : res.poStatus;

          if (res.orderStatus === "SO Created" && res.isNotCash) {
            if (!this.modalOpen) {
              this.modalOpen = true;
            }
            this.clearPollingInterval(); // stop interval
          }

          this.poId = res.poId;
          this.canNext = this.form.disableSAPEkiosk ? true : res.canNext;
          this.numberWaiting = res.numberWaiting || {counter:0,dealer:0,counter:0};

          //console.log(res)
        } catch (err) {
          console.error(err);
        }
    },
    loopGetLatest(){
      if(this.isPolling || this.intervalId) return;
      this.isPolling = true;
      this.intervalId = setInterval(async () => {
        await this.fetchLatest();
      }, 3000);
    },
    loopGetPo() {
      if (this.isPolling || this.intervalId) return;

      this.isPolling = true;
      this.intervalId = setInterval(async () => {
        try {
          const res = await this.getPO(this.poNumber);
          console.log("loop");

          let tempQueue = this.currentQueue;
          tempQueue[0].status = res.orderStatus === "" ? "Created" : res.orderStatus;

          console.log("tempQueue", tempQueue, res.orderStatus);

          if (res.orderStatus === "SO Created" && res.dealer) {
            if (!this.modalOpen) {
              this.modalOpen = true;
            }
            this.clearPollingInterval(); // stop interval
          }
        } catch (err) {
          console.error(err);
          this.clearPollingInterval(); // stop interval on error
        }
      }, 3000);
    },
    clearPollingInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
        this.isPolling = false;
      }
    },
    transformQueueNumber(queueNumber) {
      // Handle undefined, null, or empty values
      if (!queueNumber && queueNumber !== 0) {
        return '-'
      }
      
      // Convert to string to handle the transformation
      const queueStr = String(queueNumber)
      
      // Check if the queue number starts with a letter (O or C)
      const hasLetterPrefix = /^[A-Za-z]/.test(queueStr)
      
      if (hasLetterPrefix) {
        // Extract the letter prefix and numeric part
        const prefix = queueStr.charAt(0)
        const numericPart = parseInt(queueStr.slice(1))
        
        // Add 88000 to the numeric part
        const transformedNumber = numericPart + 88000
        
        // Combine prefix with transformed number
        return `${prefix}${transformedNumber}`
      } else {
        // If no letter prefix, just add 88000 to the number
        return String(parseInt(queueStr) + 88000)
      }
    },
    openMissedQueueModal() {
      // Extract warehouse from the form or use a default warehouse
      const warehouse = this.form.warehouse || 'daikin';
      
      this.fetchQueueMissed(warehouse)
        .then((data) => {
          // Transform the array of strings into table format
          this.missedQueueTableData = data.map((x) => ({
            name: x.name || '-',
            queueNumber: x.queueNumber,
            poNumber: x.poNumber,
            status: x.status
          }));
          this.modalMissedQueue = true;
        })
        .catch((err) => {
          console.error(err);
          this.$bvToast.toast(`Failed to fetch missed queue: ${err.response?.data?.errors?.[0]?.message || err.message}`, {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
        });
    },
    removeMissedQueueItem(item) {
      const warehouse = this.form.warehouse || 'daikin';

      this.removeQueueMissedItem({
        warehouse,
        queueNumber: item.queueNumber,
        poNumber: item.poNumber,
      })
        .then(() => {
          const idx = this.missedQueueTableData.findIndex(
            (x) => x.queueNumber == item.queueNumber && x.poNumber == item.poNumber
          );

          if (idx === -1) return;

          this.missedQueueTableData.splice(idx, 1);
        })
        .catch((err) => {
          console.error(err);
          this.$bvToast.toast(
            `${err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err.message}`,
            {
              title: 'Failed',
              variant: 'danger',
              solid: true,
            }
          );
        });
    }
  },
  computed: {
    title() {
      var canProcess = this.form.canProcess || []
      var canList = []

      var canString=""

      if(canProcess.includes("ALL")){
        canString = "All (Dealer Order, Cash Sales Order, Walk In Cash Order)"
      }else{
        if(canProcess.includes("EKO")){
          canList.push("Online Cash Sales")
        }
        if(canProcess.includes("EKR")){
          canList.push("Online Dealer")
        }
        if(canProcess.includes("EKC")){
          canList.push("Walk In Cash Sales")
        }

        if(canList.length > 0){
          canString = canList.join(", ")
        }
      }

      return this.form.name +", service Queue Type: " + canString
    }
  }
}
</script>